export default __webpack_public_path__ + "static/media/17.04fb5e34.jpg";